<template>
  <div class="flex-column pb-1" style="width: 47%" @click="(e) => $emit('click', e)">
    <img :src="brand.image_url" style="width: 100%"/>
    <div v-if="redemption.is_used" class="mt-n1 text-center" style="font-size: 12px">
      <strong>{{ $formatters.formatCurrency(redemption.amount_cents) }} - </strong>Redeemed
    </div>
    <div v-else class="mt-n1 text-center" style="font-size: 12px">
      <strong>{{ $formatters.formatCurrency(redemption.amount_cents) }} - </strong>issued {{ $formatters.formatDate(redemption.issued_time) }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'RewardsWalletItem',

  props: ['brand','redemption'],
}
</script>
